module.exports = __webpack_public_path__ + "media/images/pages/contributor_overview/img-12-712edb604c7a1034483d0486f8173250.png";